import { Tutorial } from '@components/tutorial/Tutorial';
import { useLobbyStore, useAppStore } from '@stores';
import { useTranslation } from 'react-i18next';
import { Step } from 'react-joyride';

export function PlanetTutorial() {
  const { t } = useTranslation(undefined, { keyPrefix: 'Tutorial.Planet' });
  const { isConnecting, tab } = useAppStore();
  const { state } = useLobbyStore();

  if (isConnecting) return null;
  if (!state?.planet) return null;
  if (tab !== 'lobby') return null;

  const steps: Step[] = [
    {
      target: '.lootinfo',
      placement: 'center',
      content: t('planet0'),
    },
    {
      target: '.lootinfo',
      content: t('planet1'),
    },
    {
      target: '.land-btn',
      content: <p className="text-primary">{t('planet2')}</p>,
    },
  ];

  return <Tutorial tutorialKey="Planet" steps={steps} />;
}